<template>
  <v-alert
    v-if="$store.getters.storeOnline.status"
    :value="showOffer && show"
    text
    prominent
    border="left"
    color="primary"
    icon="mdi-tag-outline"
    transition="scale-transition"
    width="100%"
    :class="{ 'my-0': $vuetify.breakpoint.smAndDown }"
  >
    <v-row align="start">
      <v-col class="grow"> {{ message }} </v-col>
      <v-col class="shrink">
        <v-btn icon @click="show = false">
          <v-icon v-text="'mdi-close'" />
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
export default {
  name: "OffersComponent",
  data: () => ({
    show: true,
  }),
  computed: {
    showOffer: {
      get() {
        if (this.$store.getters.storeInfo.hasOffers !== false) {
          return !this.$store.getters.storeInfo.hasOffers.isCodeRequired;
        } else {
          return false;
        }
      },
      set(val) {
        return val;
      },
    },
    message: {
      get() {
        return this.$t("offers.offer_text", {
          amount:
            this.$store.getters.storeInfo.hasOffers.type === "Amount"
              ? this.$appFormatters.formatMoney(
                  this.$store.getters.storeInfo.hasOffers.amount
                )
              : this.$store.getters.storeInfo.hasOffers.amount + "%",
        });
      },
      set(val) {
        return val;
      },
    },
  },
};
</script>
